import { useState } from "react";
import { Palette, Stack } from "@mui/material";
import { AttachmentChip } from "./AttachmentChip";
import { DocumentPreviewModal } from "../components/document/DocumentPreviewModal";
import { IAttachment } from "../types";

export const AttachmentsList = ({
  attachments,
  palette,
}: {
  attachments: IAttachment[];
  palette: Palette;
}) => {
  const [previewDoc, setPreviewDoc] = useState<IAttachment | null>(null);

  return (
    <>
      <Stack direction="row" spacing={1} flexWrap="wrap">
        {attachments.map((attachment) => (
          <AttachmentChip
            key={attachment.handle}
            name={attachment.name}
            palette={palette}
            onClick={() => setPreviewDoc(attachment)}
          />
        ))}
      </Stack>

      <DocumentPreviewModal
        doc={previewDoc}
        onClose={() => setPreviewDoc(null)}
        palette={palette}
      />
    </>
  );
};
